export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full bg-[#f7f4ef] py-24 md:py-36 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        {/* Top label */}
        <p className="text-stone-400 text-xs tracking-[0.25em] uppercase font-light mb-16">
          / About Us
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left column */}
          <div>
            <h2
              className="font-light text-stone-800 leading-snug mb-10"
              style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}
            >
              <strong className="font-semibold">DSS DOO</strong> is a team of experts developing modern applications for the iOS platform.
            </h2>
            <p className="text-stone-500 font-light leading-loose text-base md:text-lg mb-10">
              Our products are carefully crafted to enhance user experience and improve the security of mobile devices. We combine precision engineering with intuitive design to deliver tools that people genuinely rely on every day.
            </p>
            <p className="text-stone-500 font-light leading-loose text-base md:text-lg">
              Founded with a clear mission — to make mobile technology safer and more efficient — our team works at the intersection of security, performance, and elegant design.
            </p>
          </div>

          {/* Right column */}
          <div className="flex flex-col gap-12">
            {/* Team image */}
            <div className="w-full rounded-2xl overflow-hidden" style={{ height: "260px" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/38d5219d676a745fdc48ca9fd1eb0755.jpg"
                alt="DSS DOO team workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>


          </div>
        </div>

        {/* Bottom values strip */}
        <div className="mt-20 border-t border-stone-200 pt-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
          {[
            { icon: "ri-shield-check-line", title: "Security First", desc: "Every product is built with privacy and data protection as a foundational principle." },
            { icon: "ri-smartphone-line", title: "Native iOS", desc: "We build exclusively for the iOS ecosystem, ensuring seamless performance and design fidelity." },
            { icon: "ri-user-heart-line", title: "User Centric", desc: "Our design process starts and ends with the real needs of everyday mobile users." },
          ].map((item) => (
            <div key={item.title} className="flex flex-col gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-stone-900">
                <i className={`${item.icon} text-white text-lg`} />
              </div>
              <h4 className="text-stone-800 font-medium text-base">{item.title}</h4>
              <p className="text-stone-400 font-light text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
